<template>
  <div class="collectionGoods">
    <topTitle title="收藏商品">
      <button @click="editFun" :disabled='show'>{{edit?'完成':'编辑'}}</button>
    </topTitle>

    <van-tabs v-model="active" swipeable class="main" @change='qiehuan'>
       <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              offset="0"
              :immediate-check='false'
              @load="onLoad()"
            >
      <van-tab title="商品">
          <div class="goodsList">
           
              <div class="item" v-for="(item,i) in goodsList" :key="i">
                <h2 @click="toShop(item)">
                  {{item.shop_name}}
                  <img src="../../assets/localImage/path.png" alt />
                </h2>
                <div>
                  <van-checkbox v-model="item.goodshow" v-if="edit"></van-checkbox>
                  <div class="img" @click="toDetail(item)">
                    <!-- <img :src="item.goods_img" alt /> -->
                    <van-image
                      width="100%"
                      height="100%"
                      fit="cover"
                      :src="item.goods_img ? item.goods_img : $store.state.defaultgwc" 
                    />
                  </div>
                  <div class="name" @click="toDetail(item)">
                    <p>{{item.goods_name}}</p>
                    <span>￥{{item.goods_price}}</span>
                  </div>
                </div>
              </div>
          </div>
        
      </van-tab>
      <van-tab title="店铺">
        <div class="storeList">
          <!-- <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              offset="0"
              :immediate-check='false'
              @load="onLoad()"
            > -->
            <div class="item" v-for="(item,i) in storeList" :key="i">
              <div class="name">
                <van-checkbox v-model="item.storeshow" v-if="edit"></van-checkbox>
                <div class="img" @click="toShop(item)">
                  <!-- <img :src="item.logo" alt /> -->
                  <van-image
                    width="100%"
                    height="100%"
                    fit="cover"
                    :src="item.logo"
                  />
                </div>
                <p @click="toShop(item)">{{item.shop_name}}</p>
              </div>
              <img src="../../assets/localImage/path.png" alt />
            </div>
          <!-- </van-list>      -->
        </div>
      </van-tab>
            </van-list>

    </van-tabs>

    <div class="footOperation" v-if="edit">
        <button @click="cancel()">取消关注</button>
    </div>
  </div>
</template>

<script>
import topTitle from "../../components/topTitle.vue";
import { Toast } from 'vant';
export default {
  name: "collectionGoods",
  data() {
    return {
      loading: false,
      finished: false,
      active: this.$route.query.type == 1?1:0,
      edit:false,
      show:false,

      page_no: 1,
      page_size:10,
      pageNo: 1,
      pageSize:10,
      goodsList:[],
      storeList:[],
    };
  },
  components: {
    topTitle
  },
  created(){
    this.getgoosList();
    this.getstoreList();
    // this.getcollInfo()
  },
  mounted(){

  },
  methods: {
    qiehuan(name,title){
      console.log(name,title)
      this.edit = false;
      if(name == 0) {
        if(this.goodsList.length == 0){
          this.show = true;
        }else{
          this.show = false;
        }
      }
      if(name == 1){
        if(this.storeList.length == 0){
          this.show = true;
        }else{
          this.show = false;
        }
      }
    },
    toShop(obj){
      this.$router.push({path:'shopIndex',query:{shop_id:obj.shop_id}});
    },
    toDetail(obj){
      this.$router.push({path:'goodsDetail',query:{goods_id:obj.goods_id}});
    },
    cancel(){
      if(this.active == 0){
        console.log(this.goodsList)
        let arr = [];
        this.goodsList.forEach(obj=>{
          if(obj.goodshow){
            arr.push(obj.goods_id)
          }
        })
        if(arr.length>0){
            let goodsStr = arr.join(',')

            this.deleteRequest(`members/collection/goods/${goodsStr}`).then(res => {
              this.goodsList = this.goodsList.filter(obj=>{return !obj.goodshow})
              Toast.success('取消关注');
          })
        }
        
      }else if(this.active == 1){
        let arr = [];
        this.storeList.forEach(obj=>{
          if(obj.storeshow){
            arr.push(obj.shop_id)
          }
        })
        if(arr.length>0){
            let storeStr = arr.join(',')

            this.deleteRequest(`members/collection/shop/${storeStr}`).then(res => {
              this.storeList = this.storeList.filter(obj=>{return !obj.storeshow})
              Toast.success('取消关注');
          })
          }
      }
    },
    onLoad(){
      if(this.active == 0){
        this.page_no = this.page_no + 1;
        this.getgoosList();
      }else if(this.active == 1){
        this.pageNo = this.pageNo + 1;
        this.getstoreList();
      }
    },
    getgoosList(){
      this.getRequest( `members/collection/goods`,{page_no:this.page_no,page_size:this.page_size}).then(res => {
        if(res.data.code == 1){
          this.goodsList = [];
          this.loading = false;
          this.finished = true;
        }else{
          res.data.data.data.forEach(element => {
            element.goodshow = false;
          });
          this.goodsList =  this.goodsList.concat(res.data.data.data);
          this.loading = false;
          // 数据全部加载完成
          if (res.data.data.data.length < 10) {
            this.finished = true;
          }
        }
      })
    },
    getstoreList(){
      this.getRequest( `members/collection/shops`,{page_no:this.pageNo,page_size:this.pageSize}).then(res => {
        if(res.data.code == 1){
          this.storeList = [];
          this.loading = false;
          this.finished = true;
        }else{
          res.data.data.data.forEach(element => {
            element.storeshow = false;
          });
          this.storeList =  this.storeList.concat(res.data.data.data);
          this.loading = false;
          // 数据全部加载完成
          if (res.data.data.data.length < 10) {
            this.finished = true;
          }
        }
      })
    },

    editFun() {
      this.edit = !this.edit
    }
  }
};
</script>


<style scoped lang='less'>
.collectionGoods {
  /deep/.van-tabs {
    .van-tabs__wrap{position: fixed;width: 100%; z-index: 100}
    .van-tabs__content{padding-top: 90px;}
    .van-tab--active {
      color: #ff1919;
    }
    .van-tab--active .van-tab__text {
      font-size: 30px;
    }
    .van-tabs__nav .van-tab__text {
      font-size: 28px;
      line-height: 90px;
      font-family: pingFangSC-Medium;
    }
    .van-tabs__nav .van-tabs__line {
      width: 48px !important;
      height: 6px !important;
      background: linear-gradient(to right, #f00f00, #ff9176, #ffddd4);
    }
  }
  .goodsList {
    padding: 20px 18px;
    .item {
      width: 714px;
      height: 302px;
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      padding: 31px 26px;
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;

      h2 {
        font-size: 26px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        img {
          width: 12px;
          height: 20px;
          display: inline-block;
          margin-left: 10px;
        }
      }
      > div {
        margin-top: 29px;
        display: flex;
        justify-content: space-between;

        .img {
          width: 180px;
          height: 180px;
          margin-right: 30px;
        }
        .name {
          flex: 1;
          padding-bottom: 24px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          p {
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 37px;
          }
          span {
            font-size: 22px;
            font-family: AlibabaPuHuiTiM;
            color: rgba(255, 25, 25, 1);
          }
        }
      }
    }
  }
  .storeList {
    padding: 21px 18px;
    .item {
      width: 714px;
      height: 162px;
      margin: auto;
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      margin-bottom: 20px;
      padding: 29px 31px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .name {
        display: flex;
        align-items: center;
        > .img {
          width: 107px;
          height: 107px;
          margin-right: 29px;
        }
        p {
          font-size: 28px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 1);
        }
      }
      > img {
        width: 12px;
        height: 20px;
      }
    }
  }
}
</style>


